import React, {
    useCallback
} from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ViewModelForm, useDataRefresh } from 'gw-portals-viewmodel-react';
import metadata from './AddressNewServiceComponent_AX.metadata.json5';
import styles from './AddressNewServiceComponent_AX.module.scss';

function AddressNewServiceComponentAX(props) {
    const { refreshData } = useDataRefresh();

    const {
        addressVM,
        handleModelChangeAddress
    } = props;

    const handleStateItem = useCallback((code) => {
        _.set(addressVM, 'state', code.id);
        refreshData();
    }, [addressVM, refreshData]);

    const overrides = {
        '@field': {
            labelPosition: 'left'
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            handleStateItem: handleStateItem
        }
    };

    return (
        <>
            <ViewModelForm
                uiProps={metadata.addressNewService}
                model={addressVM}
                overrideProps={overrides}
                callbackMap={resolvers.resolveCallbackMap}
                onModelChange={handleModelChangeAddress}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </>
    );
}

AddressNewServiceComponentAX.propTypes = {
    addressVM: PropTypes.object.isRequired,
    handleModelChangeAddress: PropTypes.func.isRequired
};

export default withRouter(AddressNewServiceComponentAX);
